import React from "react";
const WIDTH = 90;
const DEPTH = 60;
const HEIGHT = 30;

export default {
  name: "Bath-Centre-Taps",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Bath Centre Taps",
    description: "Bath-Centre-Taps",
    image: require("./BathCentreTaps.svg"),
    svgIcon: require("./BathCentreTaps.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(${-WIDTH / 2},${DEPTH / 2}) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M50.08,74.3c-9.94,0-19.87,0-29.8,0A18.14,18.14,0,0,1,8.19,69.56a22.1,22.1,0,0,1-7.12-13.4A34.85,34.85,0,0,1,.53,50,25.83,25.83,0,0,1,1.76,43,24,24,0,0,1,5.12,36a18.45,18.45,0,0,1,12.76-8.11,13.36,13.36,0,0,1,1.9-.07c8.08,0,16.17,0,24.26,0a2.92,2.92,0,0,0,1.08-.24,2.53,2.53,0,0,1,2.15,0,2.53,2.53,0,0,0,.93.22c.85,0,1.7,0,2.55,0a4,4,0,0,0,2-.34,2.13,2.13,0,0,1,1.84.08,3.19,3.19,0,0,0,1.09.24c7.7,0,15.41,0,23.12,0a19.54,19.54,0,0,1,10.17,3C94.31,34,97.43,39,98.91,45.15A26.43,26.43,0,0,1,97.4,62.38a19.28,19.28,0,0,1-9.61,9.95,19.79,19.79,0,0,1-8.68,1.9h-29ZM48.25,32.66l-.56,0h-26a19.89,19.89,0,0,0-6.57,1,12,12,0,0,0-5.34,3.61c-3,3.54-4.18,7.86-4.52,12.4a23.33,23.33,0,0,0,1.52,10,13.9,13.9,0,0,0,7,7.92,19.16,19.16,0,0,0,8.59,1.81q28.37,0,56.71,0A16.77,16.77,0,0,0,83,68.94c4.75-1.13,8-4.16,9.86-8.79a22.91,22.91,0,0,0,1.52-8.56,20.38,20.38,0,0,0-4.11-12.8A14.78,14.78,0,0,0,84,33.94a18.56,18.56,0,0,0-7.17-1.31q-12.48,0-25,0c-.19,0-.38,0-.55,0a1.29,1.29,0,0,0,0,.19c0,.95,0,1.91,0,2.86A3,3,0,0,1,50.93,37a1.31,1.31,0,0,1-2.33,0,2.89,2.89,0,0,1-.34-1.27C48.21,34.7,48.25,33.71,48.25,32.66Zm0-2.35-.38.44a2.32,2.32,0,0,1-3.47-.16.91.91,0,0,0-.85-.42H19.81A15,15,0,0,0,9.4,34.54a18.7,18.7,0,0,0-4.73,7.12A24.19,24.19,0,0,0,2.85,51.9c.07,1.16.19,2.31.37,3.46A20.2,20.2,0,0,0,8.69,66.78a16,16,0,0,0,11.62,5c19.5.05,39,0,58.5,0a19,19,0,0,0,6.08-.94A16.89,16.89,0,0,0,95,62a23.71,23.71,0,0,0,1.71-16c-1.33-5.83-4.26-10.49-9.44-13.43A17.22,17.22,0,0,0,79,30.21c-7.61-.09-15.23,0-22.85,0a.78.78,0,0,0-.72.35,2.31,2.31,0,0,1-3.75-.05c-.07-.1-.15-.19-.3-.37v1.72h.74q12.24,0,24.47,0a26.91,26.91,0,0,1,3,.15,15.91,15.91,0,0,1,9.37,4.14,19.7,19.7,0,0,1,6.14,13,22.88,22.88,0,0,1-2.26,13.09,14.23,14.23,0,0,1-6.93,6.68A16.8,16.8,0,0,1,79,70.17q-28.22,0-56.44,0a21.44,21.44,0,0,1-7.72-1.32A14,14,0,0,1,8,63.6C5.13,59.32,4.3,54.4,4.53,49.33a22.87,22.87,0,0,1,2.76-9.8,13.59,13.59,0,0,1,9.15-7.14,23.41,23.41,0,0,1,5.6-.57H48.23ZM49,28.69c0,2.45,0,4.79,0,7.13a1.63,1.63,0,0,0,.19.64.59.59,0,0,0,1.11,0,2,2,0,0,0,.2-.91c0-2.1,0-4.2,0-6.3,0-.16,0-.32,0-.53l-.62,0Zm-4.33.81a1.59,1.59,0,0,0,.25.54c.17.18.56.42.63.37a2.34,2.34,0,0,0,.77-1A2.22,2.22,0,0,0,46,28.3a.44.44,0,0,0-.37-.12A1.34,1.34,0,0,0,44.69,29.5Zm8.64-.33c0,.49.54,1.28.89,1.29s.79-.61.79-1.08a1.3,1.3,0,0,0-1-1.23C53.67,28.14,53.33,28.65,53.33,29.17Zm-.54,1.26-.27-2A1.12,1.12,0,0,0,52.79,30.43Zm-5.88,0a1.2,1.2,0,0,0,.74-1.08.9.9,0,0,0-.45-.87Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M48.25,32.66c0,1.05,0,2,0,3A2.89,2.89,0,0,0,48.6,37a1.31,1.31,0,0,0,2.33,0,3,3,0,0,0,.35-1.27c0-1,0-1.91,0-2.86a1.29,1.29,0,0,1,0-.19c.17,0,.36,0,.55,0q12.48,0,25,0A18.56,18.56,0,0,1,84,33.94a14.78,14.78,0,0,1,6.27,4.85,20.38,20.38,0,0,1,4.11,12.8,22.91,22.91,0,0,1-1.52,8.56C91,64.78,87.76,67.81,83,68.94a16.77,16.77,0,0,1-3.93.41q-28.35,0-56.71,0a19.16,19.16,0,0,1-8.59-1.81,13.9,13.9,0,0,1-7-7.92,23.33,23.33,0,0,1-1.52-10c.34-4.54,1.52-8.86,4.52-12.4a12,12,0,0,1,5.34-3.61,19.89,19.89,0,0,1,6.57-1h26ZM50,45.39a2.31,2.31,0,1,0-2.43-2.28A2.38,2.38,0,0,0,50,45.39Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M48.23,30.31v1.51H22a23.41,23.41,0,0,0-5.6.57,13.59,13.59,0,0,0-9.15,7.14,22.87,22.87,0,0,0-2.76,9.8c-.23,5.07.6,10,3.51,14.27a14,14,0,0,0,6.77,5.23,21.44,21.44,0,0,0,7.72,1.32q28.22,0,56.44,0a16.8,16.8,0,0,0,6.88-1.32,14.23,14.23,0,0,0,6.93-6.68A22.88,22.88,0,0,0,95,49.08a19.7,19.7,0,0,0-6.14-13A15.91,15.91,0,0,0,79.53,32a26.91,26.91,0,0,0-3-.15q-12.22,0-24.47,0h-.74V30.1c.15.18.23.27.3.37a2.31,2.31,0,0,0,3.75.05.78.78,0,0,1,.72-.35c7.62,0,15.24-.05,22.85,0a17.22,17.22,0,0,1,8.35,2.36c5.18,2.94,8.11,7.6,9.44,13.43A23.71,23.71,0,0,1,95,62a16.89,16.89,0,0,1-10.15,8.92,19,19,0,0,1-6.08.94c-19.5,0-39,0-58.5,0a16,16,0,0,1-11.62-5A20.2,20.2,0,0,1,3.22,55.36c-.18-1.15-.3-2.3-.37-3.46A24.19,24.19,0,0,1,4.67,41.66,18.7,18.7,0,0,1,9.4,34.54a15,15,0,0,1,10.41-4.36H43.53a.91.91,0,0,1,.85.42,2.32,2.32,0,0,0,3.47.16Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M49,28.69h.86l.62,0c0,.21,0,.37,0,.53,0,2.1,0,4.2,0,6.3a2,2,0,0,1-.2.91.59.59,0,0,1-1.11,0,1.63,1.63,0,0,1-.19-.64C49,33.48,49,31.14,49,28.69Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M44.69,29.5a1.34,1.34,0,0,1,1-1.32.44.44,0,0,1,.37.12,2.22,2.22,0,0,1,.32,1.1,2.34,2.34,0,0,1-.77,1c-.07.05-.46-.19-.63-.37A1.59,1.59,0,0,1,44.69,29.5Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M53.33,29.17c0-.52.34-1,.67-1a1.3,1.3,0,0,1,1,1.23c0,.47-.46,1.09-.79,1.08S53.33,29.66,53.33,29.17Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M52.79,30.43a1.12,1.12,0,0,1-.27-2Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M46.91,30.46l.29-1.95a.9.9,0,0,1,.45.87A1.2,1.2,0,0,1,46.91,30.46Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              d="M50,45.39a2.31,2.31,0,1,1,0-4.62,2.31,2.31,0,1,1,0,4.62Zm0-.81a1.6,1.6,0,0,0,1.63-1.48,1.66,1.66,0,0,0-3.31,0A1.61,1.61,0,0,0,50.05,44.58Z"
              transform="translate(-0.53 -27.25)"
            />
            <path
              class="cls-1"
              d="M50.05,44.58a1.61,1.61,0,0,1-1.68-1.48,1.66,1.66,0,0,1,3.31,0A1.6,1.6,0,0,1,50.05,44.58Z"
              transform="translate(-0.53 -27.25)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
